"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_AllergyIntolerance_Reaction = exports.AllergyIntolerance_ReactionSeverityKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var AllergyIntolerance_ReactionSeverityKind;
(function (AllergyIntolerance_ReactionSeverityKind) {
    AllergyIntolerance_ReactionSeverityKind["_mild"] = "mild";
    AllergyIntolerance_ReactionSeverityKind["_moderate"] = "moderate";
    AllergyIntolerance_ReactionSeverityKind["_severe"] = "severe";
})(AllergyIntolerance_ReactionSeverityKind = exports.AllergyIntolerance_ReactionSeverityKind || (exports.AllergyIntolerance_ReactionSeverityKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_AllergyIntolerance_Reaction = t.recursion('IAllergyIntolerance_Reaction', function () {
    return t.intersection([
        t.type({
            manifestation: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            substance: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            description: t.string,
            _description: RTTI_Element_1.RTTI_Element,
            onset: RTTI_dateTime_1.RTTI_dateTime,
            _onset: RTTI_Element_1.RTTI_Element,
            severity: (0, EnumType_1.createEnumType)(AllergyIntolerance_ReactionSeverityKind, 'AllergyIntolerance_ReactionSeverityKind'),
            _severity: RTTI_Element_1.RTTI_Element,
            exposureRoute: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation)
        })
    ]);
});
//# sourceMappingURL=RTTI_AllergyIntolerance_Reaction.js.map